import { createContext } from 'react'

import type { Job } from '../api/client'

/**
 * The queue, polled once for the whole app.
 *
 * Shared rather than fetched per screen because two consumers now need it: the
 * Queue page and the unfinished-orders count in the sidebar. Two independent
 * pollers would double the request rate -- and the busy poll asks the server to
 * probe the GPU, which costs a couple of seconds server-side while the VM is
 * off, so doing it twice is worse than untidy.
 */
export interface JobsValue {
  /** Null until the first answer arrives. */
  jobs: Job[] | null
  error: string | null
  refreshNow: () => Promise<void>
}

export const JobsContext = createContext<JobsValue>({
  jobs: null,
  error: null,
  refreshNow: () => Promise.resolve(),
})
